import { useAuth, useRequestUser } from "../core/Auth"
import { useEffect, useState } from "react"
import { LayoutSplashScreen } from "../../../layout/core"
import { useParams } from "react-router-dom"

export const TokenAuth = () => {
    const { token } = useParams()
    const { getUserByToken } = useRequestUser()
    const { logout, setUser, saveAuth } = useAuth()
    const [showSplashScreen, setShowSplashScreen] = useState(true)

    useEffect(() => {
        if (!token) return

        setShowSplashScreen(true)
        getUserByToken(token)
            .then((user) => {
                saveAuth({ authType: "Custom", token })
                setUser(user)
            })
            .catch(() => logout())
            .finally(() => setShowSplashScreen(false))

        // eslint-disable-next-line
    }, [token])

    return showSplashScreen ? <LayoutSplashScreen /> : <></>
}